// Layers config
export const LAYERS_ID = {
  BUILDING_CONTOUR: 'building-contour',
  BUILDING_CONTOUR_MARKER: 'building-contour-marker',
  // BUILDING_FLOOR_OLD: [
  //   'spaces_base_fill',
  //   'spaces_base_line',
  //   'spaces_comercial_shadow',
  //   'spaces_comercial_fill',
  //   'spaces_comercial_line',
  //   'spaces_change_floor_shadow',
  //   'spaces_change_floor_fill',
  //   'spaces_change_floor_line',
  //   'spaces_luggge_shadow',
  //   'spaces_luggge_fill',
  //   'spaces_luggge_line',
  //   'spaces_other_shadow',
  //   'spaces_other_shadow_line',
  //   'spaces_other_fill',
  //   'spaces_other_line',
  //   'spaces_restaurant_shadow',
  //   'spaces_restaurant_fill',
  //   'spaces_restaurant_line',
  //   'zones_base',
  //   'zones_shadow',
  //   'zones_controlled',
  //   'zones_lines_public',
  //   'zones_lines_restricted',
  //   'zones_lines_cotrolled',
  //   'levels',
  //   'zones_restristed',
  //   'spaces_restricted_shadow',
  //   'spaces_restricted_fill',
  //   'spaces_restricted_line',
  //   'spaces_vip_shadow',
  //   'spaces_vip_fill',
  //   'spaces_vip_line',
  //   'spaces_restroom'
  // ],
  BUILDING_FLOOR: {
    SPACES_BASE_FILL: 'spaces_base_fill',
    SPACES_BASE_LINE: 'spaces_base_line',
    SPACES_COMERCIAL_SHADOW: 'spaces_comercial_shadow',
    SPACES_COMERCIAL_FILL: 'spaces_comercial_fill',
    SPACES_COMERCIAL_LINE: 'spaces_comercial_line',
    SPACES_CHANGE_FLOOR_SHADOW: 'spaces_change_floor_shadow',
    SPACES_CHANGE_FLOOR_FILL: 'spaces_change_floor_fill',
    SPACES_CHANGE_FLOOR_LINE: 'spaces_change_floor_line',
    SPACES_LUGGGE_SHADOW: 'spaces_luggge_shadow',
    SPACES_LUGGGE_FILL: 'spaces_luggge_fill',
    SPACES_LUGGGE_LINE: 'spaces_luggge_line',
    SPACES_OTHER_SHADOW: 'spaces_other_shadow',
    SPACES_OTHER_SHADOW_LINE: 'spaces_other_shadow_line',
    SPACES_OTHER_FILL: 'spaces_other_fill',
    SPACES_OTHER_LINE: 'spaces_other_line',
    SPACES_RESTAURANT_SHADOW: 'spaces_restaurant_shadow',
    SPACES_RESTAURANT_FILL: 'spaces_restaurant_fill',
    SPACES_RESTAURANT_LINE: 'spaces_restaurant_line',
    ZONES_BASE: 'zones_base',
    ZONES_SHADOW: 'zones_shadow',
    ZONES_CONTROLLED: 'zones_controlled',
    ZONES_LINES_PUBLIC: 'zones_lines_public',
    ZONES_LINES_RESTRICTED: 'zones_lines_restricted',
    ZONES_LINES_COTROLLED: 'zones_lines_cotrolled',
    LEVELS: 'levels',
    ZONES_RESTRISTED: 'zones_restristed',
    SPACES_RESTRICTED_SHADOW: 'spaces_restricted_shadow',
    SPACES_RESTRICTED_FILL: 'spaces_restricted_fill',
    SPACES_RESTRICTED_LINE: 'spaces_restricted_line',
    SPACES_VIP_SHADOW: 'spaces_vip_shadow',
    SPACES_VIP_FILL: 'spaces_vip_fill',
    SPACES_VIP_LINE: 'spaces_vip_line',
    SPACES_RESTROOM: 'spaces_restroom',
    SPACES_SECURITY_SHADOW: 'spaces_security_shadow',
    SPACES_SECURITY_FILL: 'spaces_security_fill',
    SPACES_SECURITY_LINE: 'spaces_security_line'
  },
  // TILES: 'tiles',
  POI_LIST: 'poiList',
  POI_LIST_SELECTED: 'poiListSelected',
  ROUTES: [
    'route',
    'route1',
    'route2'
  ]
}

export const LAYER_BUILDING_FLOOR = {
  id: LAYERS_ID.BUILDING_FLOOR.SPACES_BASE_FILL,
  source: 'vector',
  tiles: [],
  layers: [
    {
      id: LAYERS_ID.BUILDING_FLOOR.LEVELS,
      type: 'line',
      'source-layer': 'layer0',
      filter: {},
      paint: {
        'line-width': 1,
        'line-color': '#b5bcb9',
        'line-opacity': 1
      }
    },
    {
      id: LAYERS_ID.BUILDING_FLOOR.ZONES_BASE,
      type: 'fill',
      'source-layer': 'layer1',
      filter: {},
      paint: {
        'fill-color': '#FFF'
      }
    },
    {
      id: LAYERS_ID.BUILDING_FLOOR.ZONES_CONTROLLED,
      type: 'fill',
      'source-layer': 'layer1',
      filter: {},
      paint: {
        'fill-color': [
          'match',
          ['get', 'type'],
          'CONTROLLED', '#fed4d6',
          'transparent'
        ]
      }
    },

    {
      id: LAYERS_ID.BUILDING_FLOOR.ZONES_SHADOW,
      type: 'fill',
      'source-layer': 'layer1',
      filter: {},
      paint: {
        'fill-color': [
          'match',
          ['get', 'type'],
          'RESTRICTED', '#8d9398',
          'transparent'
        ],
        'fill-translate': [1, 1]
      }
    },

    {
      id: LAYERS_ID.BUILDING_FLOOR.ZONES_LINES_COTROLLED,
      type: 'line',
      'source-layer': 'layer1',
      filter: {},
      paint: {
        'line-color': [
          'match',
          ['get', 'type'],
          'CONTROLLED', '#ff5e6b',
          'transparent'
        ],
        'line-width': 1,
        'line-opacity': 1,
        'line-offset': -1,
        'line-dasharray': [1, 2]
      }
    },
    {
      id: LAYERS_ID.BUILDING_FLOOR.ZONES_RESTRISTED,
      type: 'fill',
      'source-layer': 'layer1',
      filter: {},
      paint: {
        'fill-color': [
          'match',
          ['get', 'type'],
          'RESTRICTED', '#CCCFD3',
          'transparent'
        ]
      }
    },
    {
      id: LAYERS_ID.BUILDING_FLOOR.ZONES_LINES_PUBLIC,
      type: 'line',
      'source-layer': 'layer1',
      filter: {},
      paint: {
        'line-color': [
          'match',
          ['get', 'type'],
          'PUBLIC', '#9a9ea7',
          'transparent'
        ],
        'line-width': 0.5,
        'line-opacity': 0.35
      }
    },
    {
      id: LAYERS_ID.BUILDING_FLOOR.ZONES_LINES_RESTRICTED,
      type: 'line',
      'source-layer': 'layer1',
      filter: {},
      paint: {
        'line-color': [
          'match',
          ['get', 'type'],
          'RESTRICTED', '#9a9ea7',
          'transparent'
        ],
        'line-width': 0.25,
        'line-opacity': 0.5
      }
    },
    {
      id: LAYERS_ID.BUILDING_FLOOR.SPACES_BASE_FILL,
      type: 'fill',
      'source-layer': 'layer2',
      filter: {},
      paint: {
        // 'fill-color': '#FFF',
        'fill-color': [
          'step', ['zoom'],
          'transparent', 17.5,
          '#FFF'
        ],
        'fill-opacity': [
          'match',
          ['get', 'uso_comerc'],
          'CONTORNOS_DE_BARRERAS_AL_TRANSITO_MAMPARAS_O_PANELES_ACRISTALADOS', 0.45,
          'STRUCTURE', 0.5,
          1
        ]
      }
    },
    {
      id: LAYERS_ID.BUILDING_FLOOR.SPACES_BASE_LINE,
      type: 'line',
      'source-layer': 'layer2',
      filter: {},
      paint: {
        'line-color': [
          'match',
          ['get', 'uso_comerc'],
          'CONTORNOS_DE_BARRERAS_AL_TRANSITO_MAMPARAS_O_PANELES_ACRISTALADOS', 'transparent',
          '#9a9ea7'
        ],
        'line-width': [
          'step', ['zoom'],
          ['match', ['get', 'uso_comerc'], 'EXTERIOR_STRUCTURE', 0.5, 0], 17.5,
          0.5, 18,
          0.8, 19,
          1, 20,
          1
        ],
        'line-opacity': [
          'step', ['zoom'],
          ['match', ['get', 'uso_comerc'], 'EXTERIOR_STRUCTURE', 0.5, 0], 16,
          0.5, 17,
          0.8, 20,
          0.8
        ]
      }
    },
    {
      id: LAYERS_ID.BUILDING_FLOOR.SPACES_COMERCIAL_SHADOW,
      type: 'fill',
      'source-layer': 'layer2',
      filter: {},
      paint: {
        'fill-color': [
          'match',
          ['get', 'uso_comerc'],
          'COMMERCIAL', '#729C00',
          'transparent'
        ],
        'fill-translate': [1, 1]
      }
    },
    {
      id: LAYERS_ID.BUILDING_FLOOR.SPACES_COMERCIAL_FILL,
      type: 'fill',
      'source-layer': 'layer2',
      filter: {},
      paint: {
        'fill-color': [
          'match',
          ['get', 'uso_comerc'],
          'COMMERCIAL', '#96ce00',
          'transparent'
        ]
      }
    },
    {
      id: LAYERS_ID.BUILDING_FLOOR.SPACES_COMERCIAL_LINE,
      type: 'line',
      'source-layer': 'layer2',
      filter: {},
      paint: {
        'line-color': [
          'match',
          ['get', 'uso_comerc'],
          'COMMERCIAL', '#3A4F00',
          'transparent'
        ],
        'line-width': 0.25,
        'line-opacity': 0.35
      }
    },
    {
      id: LAYERS_ID.BUILDING_FLOOR.SPACES_CHANGE_FLOOR_SHADOW,
      type: 'fill',
      'source-layer': 'layer2',
      filter: {},
      paint: {
        'fill-color': [
          'match',
          ['get', 'uso_comerc'],
          'CONTORNOS_DE_ASCENSORES', '#BFBA9F',
          'CONTORNOS_DE_BARRERAS_AL_TRANSITO_HUECOS_PASO_INSTALACIONES', '#8D9398',
          'CONTORNOS_DE_RAMPAS_DE_ACCESO', '#BFBA9F',
          'CONTORNOS_DE_ESCALERAS_MECANICAS', '#BFBA9F',
          'CONTORNOS_DE_ESCALERAS_NORMALES', '#BFBA9F',
          'CONTORNOS_DE_PASILLOS_RODANTES', '#BFBA9F',
          'transparent'
        ],
        'fill-translate': [1, 1]
      }
    },
    {
      id: LAYERS_ID.BUILDING_FLOOR.SPACES_CHANGE_FLOOR_FILL,
      type: 'fill',
      'source-layer': 'layer2',
      filter: {},
      paint: {
        'fill-color': [
          'match',
          ['get', 'uso_comerc'],
          'CONTORNOS_DE_ASCENSORES', '#FEF8D4',
          'CONTORNOS_DE_BARRERAS_AL_TRANSITO_HUECOS_PASO_INSTALACIONES', '#CBD0D4',
          'CONTORNOS_DE_RAMPAS_DE_ACCESO', '#FEF8D4',
          'CONTORNOS_DE_ESCALERAS_MECANICAS', '#FEF8D4',
          'CONTORNOS_DE_ESCALERAS_NORMALES', '#FEF8D4',
          'CONTORNOS_DE_PASILLOS_RODANTES', '#FEF8D4',
          'transparent'
        ]
      }
    },
    {
      id: LAYERS_ID.BUILDING_FLOOR.SPACES_CHANGE_FLOOR_LINE,
      type: 'line',
      'source-layer': 'layer2',
      filter: {},
      paint: {
        'line-color': [
          'match',
          ['get', 'uso_comerc'],
          'CONTORNOS_DE_ASCENSORES', '#E6E0BE',
          'CONTORNOS_DE_BARRERAS_AL_TRANSITO_HUECOS_PASO_INSTALACIONES', '#6D7479',
          'CONTORNOS_DE_RAMPAS_DE_ACCESO', '#E6E0BE',
          'CONTORNOS_DE_ESCALERAS_MECANICAS', '#E6E0BE',
          'CONTORNOS_DE_ESCALERAS_NORMALES', '#E6E0BE',
          'CONTORNOS_DE_PASILLOS_RODANTES', '#E6E0BE',
          'transparent'
        ],
        'line-width': 0.25
      }
    },
    {
      id: LAYERS_ID.BUILDING_FLOOR.SPACES_LUGGGE_SHADOW,
      type: 'fill',
      'source-layer': 'layer2',
      filter: {},
      paint: {
        'fill-color': [
          'match',
          ['get', 'uso_comerc'],
          'LUGGAGE', '#BFAB8F',
          'transparent'
        ],
        'fill-translate': [1, 1]
      }
    },
    {
      id: LAYERS_ID.BUILDING_FLOOR.SPACES_LUGGGE_FILL,
      type: 'fill',
      'source-layer': 'layer2',
      filter: {},
      paint: {
        'fill-color': [
          'match',
          ['get', 'uso_comerc'],
          'LUGGAGE', '#FFE4BF',
          'transparent'
        ]
      }
    },
    {
      id: LAYERS_ID.BUILDING_FLOOR.SPACES_LUGGGE_LINE,
      type: 'line',
      'source-layer': 'layer2',
      filter: {},
      paint: {
        'line-color': [
          'match',
          ['get', 'uso_comerc'],
          'LUGGAGE', '#E6CEAC',
          'transparent'
        ],
        'line-width': 0.25
      }
    },
    {
      id: LAYERS_ID.BUILDING_FLOOR.SPACES_OTHER_SHADOW,
      type: 'fill',
      'source-layer': 'layer2',
      filter: {},
      paint: {
        'fill-color': [
          'match',
          ['get', 'uso_comerc'],
          'OTHER', '#BCBF95',
          'transparent'
        ],
        'fill-translate': [1, 1]
      }
    },
    {
      id: LAYERS_ID.BUILDING_FLOOR.SPACES_OTHER_SHADOW_LINE,
      type: 'line',
      'source-layer': 'layer2',
      filter: {},
      paint: {
        'line-color': [
          'match',
          ['get', 'uso_comerc'],
          'OTHER', '#595741',
          'transparent'
        ],
        'line-width': 0.25
      }
    },
    {
      id: LAYERS_ID.BUILDING_FLOOR.SPACES_OTHER_FILL,
      type: 'fill',
      'source-layer': 'layer2',
      filter: {},
      paint: {
        'fill-color': [
          'match',
          ['get', 'uso_comerc'],
          'OTHER', '#EEF2BD',
          'transparent'
        ]
      }
    },
    {
      id: LAYERS_ID.BUILDING_FLOOR.SPACES_OTHER_LINE,
      type: 'line',
      'source-layer': 'layer2',
      filter: {},
      paint: {
        'line-color': [
          'match',
          ['get', 'uso_comerc'],
          'OTHER', '#DBD7A0',
          'transparent'
        ],
        'line-width': 0.25
      }
    },
    {
      id: LAYERS_ID.BUILDING_FLOOR.SPACES_RESTAURANT_SHADOW,
      type: 'fill',
      'source-layer': 'layer2',
      filter: {},
      paint: {
        'fill-color': [
          'match',
          ['get', 'uso_comerc'],
          'RESTAURANT', '#729C00',
          'transparent'
        ],
        'fill-translate': [1, 1]
      }
    },
    {
      id: LAYERS_ID.BUILDING_FLOOR.SPACES_RESTAURANT_FILL,
      type: 'fill',
      'source-layer': 'layer2',
      filter: {},
      paint: {
        'fill-color': [
          'match',
          ['get', 'uso_comerc'],
          'RESTAURANT', '#96ce00',
          'transparent'
        ]
      }
    },
    {
      id: LAYERS_ID.BUILDING_FLOOR.SPACES_RESTAURANT_LINE,
      type: 'line',
      'source-layer': 'layer2',
      filter: {},
      paint: {
        'line-color': [
          'match',
          ['get', 'uso_comerc'],
          'RESTAURANT', '#3A4F00',
          'transparent'
        ],
        'line-width': 0.25,
        'line-opacity': 0.35
      }
    },

    {
      id: LAYERS_ID.BUILDING_FLOOR.SPACES_RESTRICTED_SHADOW,
      type: 'fill',
      'source-layer': 'layer2',
      filter: {},
      paint: {
        'fill-color': [
          'match',
          ['get', 'uso_comerc'],
          'RESTRICTED', '#8d9398',
          'transparent'
        ],
        'fill-translate': [1, 1]
      }
    },
    {
      id: LAYERS_ID.BUILDING_FLOOR.SPACES_RESTRICTED_FILL,
      type: 'fill',
      'source-layer': 'layer2',
      filter: {},
      paint: {
        'fill-color': [
          'match',
          ['get', 'uso_comerc'],
          'RESTRICTED', '#CCCFD3',
          'transparent'
        ]
      }
    },
    {
      id: LAYERS_ID.BUILDING_FLOOR.SPACES_RESTRICTED_LINE,
      type: 'line',
      'source-layer': 'layer2',
      filter: {},
      paint: {
        'line-color': [
          'match',
          ['get', 'uso_comerc'],
          'RESTRICTED', '#9a9ea7',
          'transparent'
        ],
        'line-width': 0.25,
        'line-opacity': 0.35
      }
    },
    {
      id: LAYERS_ID.BUILDING_FLOOR.SPACES_VIP_SHADOW,
      type: 'fill',
      'source-layer': 'layer2',
      filter: {},
      paint: {
        'fill-color': [
          'match',
          ['get', 'uso_comerc'],
          'VIP', '#71878c',
          'transparent'
        ],
        'fill-translate': [1, 1]
      }
    },
    {
      id: LAYERS_ID.BUILDING_FLOOR.SPACES_VIP_LINE,
      type: 'fill',
      'source-layer': 'layer2',
      filter: {},
      paint: {
        'fill-color': [
          'match',
          ['get', 'uso_comerc'],
          'VIP', '#adc7cc',
          'transparent'
        ]
      }
    },
    {
      id: LAYERS_ID.BUILDING_FLOOR.SPACES_VIP_FILL,
      type: 'line',
      'source-layer': 'layer2',
      filter: {},
      paint: {
        'line-color': [
          'match',
          ['get', 'uso_comerc'],
          'VIP', '#ff5e6b',
          'transparent'
        ],
        'line-width': 1,
        'line-opacity': 1,
        'line-offset': -1,
        'line-dasharray': [1, 2]
      }
    },
    {
      id: LAYERS_ID.BUILDING_FLOOR.SPACES_RESTROOM,
      type: 'fill',
      'source-layer': 'layer2',
      filter: {},
      paint: {
        'fill-color': [
          'match',
          ['get', 'uso_comerc'],
          'RESTROOM', '#9ab7bc',
          'transparent'
        ]
      }
    },
    {
      id: LAYERS_ID.BUILDING_FLOOR.SPACES_SECURITY_FILL,
      type: 'fill',
      'source-layer': 'layer2',
      filter: {},
      paint: {
        'fill-color': [
          'match',
          ['get', 'uso_comerc'],
          'SECURITY', '#fae0e1',
          'transparent'
        ],
        'fill-opacity': 0.7
      }
    },
    {
      id: LAYERS_ID.BUILDING_FLOOR.SPACES_SECURITY_LINE,
      type: 'line',
      'source-layer': 'layer2',
      filter: {},
      paint: {
        'line-color': [
          'match',
          ['get', 'uso_comerc'],
          'SECURITY', '#ff5e6b',
          'transparent'
        ],
        'line-width': 1,
        'line-opacity': 1,
        'line-offset': -1,
        'line-dasharray': [1, 2]
      }
    }
  ]
}

export const LAYER_ROUTE = {
  id: LAYERS_ID.ROUTES[0],
  source: 'geojson',
  data: undefined,
  layers: [
    {
      type: 'line',
      paint: {
        'line-color': [
          'case',
          ['has', 'building'],
          '#0080B1',
          '#71777D'
        ],
        'line-opacity': 0.8,
        'line-width': 7
      },
      layout: {
        'line-cap': 'round',
        'line-join': 'round'
      }
    },
    {
      id: LAYERS_ID.ROUTES[1],
      type: 'line',
      paint: {
        'line-color': [
          'case',
          ['has', 'building'],
          '#00ADD0',
          '#1A2732'
        ],
        'line-width': 3
      },
      layout: {
        'line-cap': 'round',
        'line-join': 'round'
      }
    }
  ]
}

export const LAYER_ROUTE_ARROW = {
  id: LAYERS_ID.ROUTES[2],
  source: 'geojson',
  data: undefined,
  layers: [
    {
      type: 'symbol',
      layout: {
        'icon-image': 'route-direction',
        'icon-size': 0.5,
        'icon-rotate': ['get', 'angle'],
        'icon-rotation-alignment': 'map'
      },
      paint: {}
    }
  ]
}

export const ROUTE_ARROW_CHUNK = 0.015

export const LAYER_CONTOUR = {
  id: LAYERS_ID.BUILDING_CONTOUR,
  source: 'geojson',
  data: undefined,
  layers: [
    {
      type: 'fill',
      paint: {
        'fill-opacity': 0.2,
        'fill-color': ['get', 'color']
      },
      layout: {
        'fill-sort-key': ['*', ['get', 'priority'], -1],
        visibility: 'visible'
      },
      filter: ['==', ['get', 'category'], 'TERMINAL']
    }
  ]
}

export const LAYER_CONTOUR_MARKER = {
  id: LAYERS_ID.BUILDING_CONTOUR_MARKER,
  source: 'geojson',
  data: undefined,
  layers: [
    {
      id: LAYERS_ID.BUILDING_CONTOUR_MARKER,
      type: 'symbol',
      layout: {
        'icon-image': ['get', 'poi_name'],
        'symbol-sort-key': ['*', ['get', 'priority'], -1],
        'icon-size': 1,
        visibility: 'visible'
      }
    }
  ]
}

export const LAYER_POIS = {
  id: LAYERS_ID.POI_LIST,
  source: 'geojson',
  data: undefined,
  layers: [
    {
      type: 'symbol',
      layout: {
        'icon-image': [
          'concat',
          ['get', 'iconMap'],
          '-mk'
        ],
        'symbol-sort-key': ['*', ['get', 'priority'], -1],
        'icon-size': 0.5,
        visibility: 'visible',
        'icon-anchor': 'center'
      },
      filter: null
    }
  ]
}

export const LAYER_POIS_SELECTED = {
  id: LAYERS_ID.POI_LIST_SELECTED,
  source: 'geojson',
  data: {
    'type': 'FeatureCollection',
    'features': []
  },
  layers: [
    {
      type: 'symbol',
      layout: {
        'icon-image': [
          'concat',
          ['get', 'iconMap'],
          '-selmk'
        ],
        'icon-size': 0.75,
        visibility: 'visible',
        'icon-anchor': 'bottom'
      }
    }
  ]
}

export const UNCATEGORIZED_POIS = {
  '-1': {
    icon: 'marcadores/pp_32-mk.svg',
    iconMap: 'pp_32',
    name: 'STAIRS'
  },
  '-2': {
    icon: 'marcadores/pp_34-mk.svg',
    iconMap: 'pp_34',
    name: 'ESCALATOR'
  },
  '-3': {
    icon: 'marcadores/pp_35-mk.svg',
    iconMap: 'pp_35',
    name: 'ELEVATOR'
  },
  '-4': {
    icon: 'marcadores/pp_43-mk.svg',
    iconMap: 'pp_43',
    name: 'RAMP'
  },
  '-5': {
    icon: 'marcadores/pp_36-mk.svg',
    iconMap: 'pp_36',
    name: 'MECHANICAL_CORRIDOR'
  }
}

export const UNCATEGORIZED_POIS_KEYS = Object.keys(UNCATEGORIZED_POIS)
